import React, {Component} from "react";
import {Backdrop, CircularProgress, withStyles} from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import {withRouter} from "react-router-dom";
import axios from "axios";
import {withSnackbar} from 'material-ui-snackbar-provider';
import {withTranslation} from 'react-i18next';
import customConstants from "Constants";
import GaugeChart from 'react-gauge-chart'
import moment from "moment";
import i18n from "i18n";

const styles = theme => ({
    wrapper: {
        position: "relative",
        backgroundColor: '#fff'
    },

    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12
    }
});

const chartStyle = {
    height: 150,
    marginTop: 50
}



class UserUsage extends Component {
    state = {
        waitingUserList: [],
        loading: false,
        value: 0,
        maxValue: 0,
        error: false,
        milestoneDate: null,
        control: null,
    }

    componentDidMount() {
        this.setState({loading: true});
        // get request will be for approval list
        axios.get(customConstants.API_URL + "/reporting/charging")
            .then((res) => {
                try {
                    console.log(res)
                    const maxValue = Number(res?.data?.packageSize ?? 0)
                    const value = Number(res?.data?.count ?? 0)
                    this.setState({
                        maxValue: Number.isFinite(maxValue) ? maxValue : 0,
                        value: Number.isFinite(value) ? value : 0,
                        milestoneDate: res?.data?.milestoneDate || null,
                        control: res?.data?.control ?? null,
                        loading: false,
                        error: false,
                    });
                } catch (e) {
                    console.log(e)
                    this.props.snackbar.showMessage(this.props.t("No package information is available to display. Please contact the support team for assistance."), 'error');
                    this.setState({loading: false, error: true});
                }
            }).catch((e) => {
            this.props.snackbar.showMessage(this.props.t("No package information is available to display. Please contact the support team for assistance."), 'error');
            this.setState({loading: false, error: true});
        })
    }




    render() {
        const used = Math.max(0, Number(this.state.value) || 0)
        const total = Math.max(0, Number(this.state.maxValue) || 0)
        const remaining = Math.max(0, total - used)
        const percentUsed = total > 0 ? Math.min(100, Math.round((used * 100) / total)) : 0
        const milestoneDateFormatted = this.state.milestoneDate
            ? moment(this.state.milestoneDate).local().locale(i18n.language).format("DD/MM/YYYY HH:mm")
            : "-"
        const controlRaw =
            this.state.control !== null && this.state.control !== undefined
                ? String(this.state.control).trim()
                : ""
        const controlTranslated =
            controlRaw !== "" ? this.props.t(controlRaw) : "-"

        return (
            <section className="section_wrapper">
                <div className="section_header">
                    <h2>{this.props.t("Usage Statistics")}</h2>
                </div>
                {(this.state.loading === true) ?
                    <Backdrop style={{
                        zIndex: 999,
                        color: '#fff'
                    }} open={this.state.loading}><CircularProgress
                        color="secondary"/></Backdrop> : null}

                <Card style={{maxWidth: 720}}>
                    <CardContent style={{backgroundColor: '#f1f1f1', borderRadius: 10,marginTop: 20}}>
                        {this.state.error ? (
                            <Typography variant="body2" style={{color: '#666'}}>
                                {this.props.t("No package information is available to display. Please contact the support team for assistance.")}
                            </Typography>
                        ) : (
                            <>
                                <Grid container spacing={1} style={{marginBottom: 10}}>
                                    <Grid item xs={12} md={3}>
                                        <strong>{this.props.t('Milestone Date')}</strong>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        {milestoneDateFormatted}
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <strong>{this.props.t('Control')}</strong>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        {controlTranslated}
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <strong>{this.props.t('Total Package')}</strong>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        {total}
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <strong>{this.props.t('Used')}</strong>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        {used}
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <strong>{this.props.t('Remaining')}</strong>
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        {remaining}
                                    </Grid>
                                </Grid>

                                {total === 0 ? (
                                    <Typography variant="body2" style={{color: '#666'}}>
                                        {this.props.t("No package information is available to display. Please contact the support team for assistance.")}
                                    </Typography>
                                ) : (
                                    <>
                                        <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
                                            <div style={{flex: 1}}>
                                                <LinearProgress variant="determinate" value={percentUsed} />
                                            </div>
                                            <div style={{minWidth: 70, textAlign: 'right', color: '#666'}}>
                                                {percentUsed}%
                                            </div>
                                        </div>

                                        <div style={{display: 'inline-block'}}>
                                            <GaugeChart
                                                id="gauge-chart1"
                                                style={chartStyle}
                                                type="semicircle"
                                                textColor="#000"
                                                nrOfLevels={total}
                                                arcsLength={[0.3, 0.5, 0.2]}
                                                colors={['#5BE12C', '#F5CD19', '#EA4228']}
                                                percent={used / total}
                                                arcPadding={0.02}
                                            />
                                            <div style={{textAlign: 'center'}}>{used} / {total}</div>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </CardContent>
                </Card>


            </section>
        );
    }
}

export default withTranslation()(withStyles(styles, {withTheme: true})(withSnackbar()(withRouter(
    UserUsage
))));
